import React from "react";
import { Link } from "react-router-dom";

const PoliticalPartyCard = ({ name, logo, slogan, candidatesCount, slug, isTop }) => {
  return (
    <div className="relative bg-white shadow-md rounded-xl overflow-hidden border border-gray-200 hover:shadow-xl transition hover:ring-2 hover:ring-green-600 group">
      {/* Tricolor Badge */}
      <div className="absolute top-2 left-2 text-xs font-bold bg-gradient-to-r from-orange-500 via-white to-green-500 px-2 py-0.5 rounded-full shadow-sm">
        पार्टी
      </div>

      {isTop && (
        <div className="absolute top-2 right-2 bg-yellow-400 text-xs text-white font-bold px-2 py-0.5 rounded-full shadow">
          🔥 Top Party
        </div>
      )}

      <div className="p-4 flex items-center space-x-4">
        <img
          src={logo || "/image/default-party.png"}
          alt={name}
          className="w-16 h-16 object-contain rounded-full border border-blue-600 shadow-sm group-hover:ring-2"
        />
        <div className="flex flex-col">
          <h3 className="text-lg font-bold text-gray-800">{name}</h3>
          <p className="text-sm text-gray-500 italic">{slogan}</p>
          <p className="text-sm text-gray-600 mt-1">
            {candidatesCount} candidates •{" "}
            <Link
              to={`/party/${slug}`}
              className="text-blue-600 hover:underline font-medium"
            >
              View All →
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default PoliticalPartyCard;
